import {
  AmbientLight,
  BackSide,
  FlatShading,
  Mesh,
  MeshPhongMaterial,
  PerspectiveCamera,
  Scene,
  SphereBufferGeometry,
  TextureLoader,
  WebGLRenderer,
} from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

class OrbViewScene {
  constructor() {
    this.canvas = null;
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.textureLoader = null;
    this.controls = null;
    this.sizes = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.skyboxMaterial = null;
    this.skyboxGeometry = null;
    this.skyboxMesh = null;
  }

  init = () => {
    this.canvas = document.getElementById("orb-view-canvas");
    this.scene = new Scene();
    this.textureLoader = new TextureLoader();

    this.scene.rotation.y = Math.PI;

    this.initCamera();
    this.initRenderer();
    this.initControls();
    this.initLight();
    this.createSkybox();

    window.addEventListener("resize", this.handleWindowResize);

    this.onAnimationFrameHandler();
  };

  createSkybox = () => {
    const mapUrl = "./design/panorama/petrovaradin.jpg";
    const map = this.textureLoader.load(mapUrl);

    this.skyboxGeometry = new SphereBufferGeometry(200, 70, 70);
    this.skyboxMaterial = new MeshPhongMaterial({
      map: map,
      shading: FlatShading,
    });
    this.skyboxMaterial.side = BackSide;
    this.skyboxMesh = new Mesh(this.skyboxGeometry, this.skyboxMaterial);
    this.scene.add(this.skyboxMesh);
  };

  changeSkyboxBackground = (textureUrl, onComplete) => {
    this.textureLoader.load(textureUrl, (texture) => {
     this.skyboxMesh.material.map = texture;
     if(onComplete)
      onComplete()
    })
  }

  initCamera = () => {
    this.camera = new PerspectiveCamera(
      65,
      this.sizes.width / this.sizes.height,
      0.1,
      1000
    );
    this.camera.position.z = 2;
  };

  initRenderer = () => {
    this.renderer = new WebGLRenderer({
      antialias: true,
      canvas: this.canvas,
    });
    this.renderer.setSize(this.sizes.width, this.sizes.height);

    this.renderer.setClearColor(0x000000);
    this.renderer.domElement.style.cursor = "move";
  };

  initControls = () => {
    this.controls = new OrbitControls(this.camera, this.canvas);
    this.controls.enableDamping = true;
    this.controls.enableZoom = false;
  };

  initLight = () => {
    const light = new AmbientLight(0xffffff);
    this.scene.add(light);
  };

  onAnimationFrameHandler = () => {
    this.renderer.render(this.scene, this.camera);

    window.requestAnimationFrame(() => this.onAnimationFrameHandler());
  };

  handleWindowResize = () => {
    this.sizes.width = window.innerWidth;
    this.sizes.height = window.innerHeight;

    this.camera.aspect = this.sizes.width / this.sizes.height;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  };
}

export default new OrbViewScene();
